<template>
    <div class="test-container-fontautoscale">
        <div ref="resizeContainer"
             :style="textContainerStyle"
             class="resizable-container-fontautoscale elevation-8">
            {{ text }}
        </div>

        <v-text-field v-model="text"
                      :style="{
                            position: 'absolute',
                            bottom: '8px',
                            width: '40%',
                            'background-color': 'white'
                      }"
                      hide-details
                      label="Text"
                      outlined />
    </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    data() {
        return {
            resizeObserverCloseCallback: null,
            text: 'Test text 123',

            width: 10,
            height: 10,
            lineHeight: 1.15,

            textContainerStyle: {}
        }
    },
    async mounted() {
        const resizeObserver = new ResizeObserver((entries) => {
            this.width = entries[0].contentBoxSize[0].inlineSize
            this.height = entries[0].contentBoxSize[0].blockSize
        })

        resizeObserver.observe(this.$refs.resizeContainer)

        this.resizeObserverCloseCallback = () => resizeObserver.unobserve(this.$refs.resizeContainer)
    },
    beforeDestroy() {
        this.resizeObserverCloseCallback?.()
    },
    methods: {
        setTextContainerStyle() {
            this.textContainerStyle = this.$refs.resizeContainer ? {
                fontSize: `${window.calculateFontAutosize(this.$refs.resizeContainer, this.width, this.height, this.text, { lineHeight: this.lineHeight }, 10)}px`,
                lineHeight: this.lineHeight
            } : {}
        }
    },
    watch: {
        width() {
            this.setTextContainerStyle()
        },
        height() {
            this.setTextContainerStyle()
        },
        text() {
            this.setTextContainerStyle()
        }
    }
})
</script>

<style>
.test-container-fontautoscale {
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
}
.test-container-fontautoscale .resizable-container-fontautoscale {
    width: 340px;
    height: 530px;

    resize: both;
    overflow: auto;

    padding: 16px;

    border-radius: 8px;
    outline: #0a568c solid 2px;
    background-color: white;
}
</style>
